export const BLACKLISTED_PARAMS_SEO_PAGINATION = ['referer_id', 'gclid'];
